const $primaryPic = document.querySelector('#primary-img');

let $thumbnailPics = document.querySelectorAll('.thumbnail-image');

const replacePrimaryPic = function () {
    document.querySelector('.thumbnail-image.active').classList.remove('active');
    this.classList.add('active');

    const jpgSrc = this.querySelector('[type="image/jpeg"]').getAttribute('srcset');
    const webpSrc = this.querySelector('[type="image/webp"]').getAttribute('srcset');

    $primaryPic.querySelector('[type="image/webp"]').setAttribute('srcset', webpSrc)
    $primaryPic.querySelector('[type="image/jpeg"]').setAttribute('srcset', jpgSrc)
    $primaryPic.querySelector('img').setAttribute('src', jpgSrc);
}

$thumbnailPics.forEach($pic => $pic.addEventListener('click', replacePrimaryPic));